import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskCmdbInsightObjectTypeConfigurationRoute: InvariantJiraRoute = {
	name: 'servicedesk-cmdb-object-type-configuration',
	path: '/jira/servicedesk/insight/configure/object-type/:objectTypeId',
};
